var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{ref:"wrapper",staticClass:"video-wrapper",class:( _obj = {}, _obj[_vm.size] = true, _obj ),attrs:{"flat":""},on:{"click":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }